// Survey action handlers
export const createSurveyActionHandlers = ({
  setStatusConfirmModal,
  setIsDeleteModalOpen,
  currentSurvey,
  selectedSurvey,
  instantSurveys,
  values,
  setFieldValue,
  setAssessmentStatus,
  editAccount,
  setSubmitting,
  onSurveySelect,
  setIsDeleting,
  deleteModalStep,
  setDeleteModalStep,
  statusConfirmModal,
}) => {

  const handleLaunchSurvey = () => {
    setStatusConfirmModal({ open: true, type: 'launch', loading: false, step: 1 });
  };

  const handleConfirmLaunch = () => {
    setStatusConfirmModal(prev => ({ ...prev, loading: true }));
    // Update survey status to active
    const updatedSurvey = {
      ...currentSurvey,
      status: 'active',
    };

    // Update in the parent form's instantSurveys array
    const currentSurveys = instantSurveys || [];
    const updatedSurveys = currentSurveys.map(survey =>
      survey.key === selectedSurvey ? updatedSurvey : survey,
    );

    // Create complete form values object (like in modal)
    const _values = { ...values, instantSurveys: updatedSurveys };

    // Trigger main form submit with complete values (following modal pattern)
    if (editAccount) {
      // Store a reference to handle the submission result (like in modal)
      window.currentModalSubmitHandler = {
        onSuccess: () => {
          setFieldValue('instantSurveys', updatedSurveys);
          setAssessmentStatus('active');
          setStatusConfirmModal({ open: false, type: '', loading: false, step: 1 });
        },
        onError: (error) => {
          console.error('Failed to launch survey:', error);
          setStatusConfirmModal(prev => ({ ...prev, loading: false }));
        },
      };

      editAccount(_values, { setSubmitting });
    }
  };

  const handleDeactivateSurvey = () => {
    setStatusConfirmModal({ open: true, type: 'deactivate', loading: false, step: 1 });
  };

  const handleConfirmDeactivate = () => {
    setStatusConfirmModal(prev => ({ ...prev, loading: true }));
    // Update survey status to inactive
    const updatedSurvey = {
      ...currentSurvey,
      status: 'inactive',
    };

    // Update in the parent form's instantSurveys array
    const currentSurveys = instantSurveys || [];
    const updatedSurveys = currentSurveys.map(survey =>
      survey.key === selectedSurvey ? updatedSurvey : survey,
    );

    // Create complete form values object (like in modal)
    const _values = { ...values, instantSurveys: updatedSurveys };

    // Trigger main form submit with complete values (following modal pattern)
    if (editAccount) {
      // Store a reference to handle the submission result (like in modal)
      window.currentModalSubmitHandler = {
        onSuccess: () => {
          setFieldValue('instantSurveys', updatedSurveys);
          setAssessmentStatus('inactive');
          setStatusConfirmModal({ open: false, type: '', loading: false, step: 1 });
        },
        onError: (error) => {
          console.error('Failed to deactivate survey:', error);
          setStatusConfirmModal(prev => ({ ...prev, loading: false }));
        },
      };

      editAccount(_values, { setSubmitting });
    }
  };

  const handleRelaunchSurvey = () => {
    setStatusConfirmModal({ open: true, type: 'relaunch', loading: false, step: 1 });
  };

  const handleConfirmRelaunch = () => {
    setStatusConfirmModal(prev => ({ ...prev, loading: true }));
    // Update survey status from inactive to active
    const updatedSurvey = {
      ...currentSurvey,
      status: 'active',
    };

    // Update in the parent form's instantSurveys array
    const currentSurveys = instantSurveys || [];
    const updatedSurveys = currentSurveys.map(survey =>
      survey.key === selectedSurvey ? updatedSurvey : survey,
    );

    // Create complete form values object (like in modal)
    const _values = { ...values, instantSurveys: updatedSurveys };

    // Trigger main form submit with complete values (following modal pattern)
    if (editAccount) {
      // Store a reference to handle the submission result (like in modal)
      window.currentModalSubmitHandler = {
        onSuccess: () => {
          setFieldValue('instantSurveys', updatedSurveys);
          setAssessmentStatus('active');
          setStatusConfirmModal({ open: false, type: '', loading: false, step: 1 });
        },
        onError: (error) => {
          console.error('Failed to relaunch survey:', error);
          setStatusConfirmModal(prev => ({ ...prev, loading: false }));
        },
      };

      editAccount(_values, { setSubmitting });
    }
  };

  const handleDeleteSurvey = () => {
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDelete = () => {
    // If on step 1, go to step 2
    if (deleteModalStep === 1) {
      setDeleteModalStep(2);
      return;
    }

    setIsDeleting(true);

    // Remove survey from the instantSurveys array
    const currentSurveys = instantSurveys || [];
    const updatedSurveys = currentSurveys.filter(survey => survey.key !== selectedSurvey);

    // Create complete form values object (like in modal)
    const _values = { ...values, instantSurveys: updatedSurveys };

    // Trigger main form submit with complete values (following modal pattern like in AddInstantSurveyModal)
    if (editAccount) {
      // Store a reference to handle the submission result (like in modal)
      window.currentModalSubmitHandler = {
        onSuccess: () => {
          setFieldValue('instantSurveys', updatedSurveys);
          setIsDeleteModalOpen(false);
          setIsDeleting(false);
          setDeleteModalStep(1); // Reset modal step
          // Reset selection since the survey is deleted
          if (onSurveySelect) {
            onSurveySelect(null);
          }
        },
        onError: (error) => {
          console.error('editAccount onError called:', error);
          setIsDeleting(false);
          setDeleteModalStep(1); // Reset modal step on error too
        },
      };

      editAccount(_values, { setSubmitting });
    } else {
      console.log('editAccount not available');
    }
  };

  const handleArchiveSurvey = () => {
    setStatusConfirmModal({ open: true, type: 'archive', loading: false, step: 1 });
  };

  const handleConfirmArchive = () => {
    setStatusConfirmModal(prev => ({ ...prev, loading: true }));
    // Update survey status to archived
    const updatedSurvey = {
      ...currentSurvey,
      status: 'archived',
    };

    // Update in the parent form's instantSurveys array
    const currentSurveys = instantSurveys || [];
    const updatedSurveys = currentSurveys.map(survey =>
      survey.key === selectedSurvey ? updatedSurvey : survey,
    );

    // Create complete form values object
    const _values = { ...values, instantSurveys: updatedSurveys };

    // Trigger main form submit
    if (editAccount) {
      // Store a reference to handle the submission result (like in modal)
      window.currentModalSubmitHandler = {
        onSuccess: () => {
          setFieldValue('instantSurveys', updatedSurveys);
          setAssessmentStatus('archived');
          setStatusConfirmModal({ open: false, type: '', loading: false, step: 1 });
        },
        onError: (error) => {
          console.error('Failed to archive survey:', error);
          setStatusConfirmModal(prev => ({ ...prev, loading: false }));
        },
      };

      editAccount(_values, { setSubmitting });
    }
  };

  const handleConfirmUnarchive = () => {
    setStatusConfirmModal(prev => ({ ...prev, loading: true }));
    // Update survey status to inactive
    const updatedSurvey = {
      ...currentSurvey,
      status: 'inactive',
    };

    // Update in the parent form's instantSurveys array
    const currentSurveys = instantSurveys || [];
    const updatedSurveys = currentSurveys.map(survey =>
      survey.key === selectedSurvey ? updatedSurvey : survey,
    );

    // Create complete form values object
    const _values = { ...values, instantSurveys: updatedSurveys };

    // Trigger main form submit
    if (editAccount) {
      // Store a reference to handle the submission result (like in modal)
      window.currentModalSubmitHandler = {
        onSuccess: () => {
          setFieldValue('instantSurveys', updatedSurveys);
          setAssessmentStatus('inactive');
          setStatusConfirmModal({ open: false, type: '', loading: false, step: 1 });
        },
        onError: (error) => {
          console.error('Failed to unarchive survey:', error);
          setStatusConfirmModal(prev => ({ ...prev, loading: false }));
        },
      };

      editAccount(_values, { setSubmitting });
    }
  };

  const handleConfirmStatusChange = () => {
    // For archive action, check if we need to go to step 2
    if (statusConfirmModal.type === 'archive' && statusConfirmModal.step === 1) {
      setStatusConfirmModal(prev => ({ ...prev, step: 2 }));
      return;
    }

    switch (statusConfirmModal.type) {
      case 'launch':
        handleConfirmLaunch();
        break;
      case 'deactivate':
        handleConfirmDeactivate();
        break;
      case 'relaunch':
        handleConfirmRelaunch();
        break;
      case 'archive':
        handleConfirmArchive();
        break;
      case 'unarchive':
        handleConfirmUnarchive();
        break;
      default:
        break;
    }
  };

  return {
    handleLaunchSurvey,
    handleDeactivateSurvey,
    handleRelaunchSurvey,
    handleArchiveSurvey,
    handleDeleteSurvey,
    handleConfirmDelete,
    handleConfirmStatusChange,
  };
};
